import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from './constants';
import logger from './utils/logger';

// Initialize Mixpanel only if token is available
let mixpanelInitialized = false;

if (MIXPANEL_TOKEN && MIXPANEL_TOKEN.trim() !== '') {
  try {
    mixpanel.init(MIXPANEL_TOKEN, {
      api_host: 'https://api-eu.mixpanel.com'
    });
    mixpanelInitialized = true;
    logger.log('Mixpanel initialized successfully');
  } catch (error) {
    logger.error('Error initializing Mixpanel:', error);
  }
} else {
  logger.warn('Mixpanel token not configured, analytics will be disabled');
}

// Helper function to safely execute mixpanel operations
const safeMixpanelOperation = (operation) => {
  if (!mixpanelInitialized) {
    logger.log('Mixpanel not initialized, skipping analytics operation');
    return;
  }
  
  try {
    operation();
  } catch (error) {
    logger.error('Error executing Mixpanel operation:', error);
  }
};

// Identify user
export const identifyUser = (userId, userProperties) => {
  safeMixpanelOperation(() => {
  mixpanel.identify(userId);
  mixpanel.people.set(userProperties);
  });
};

// Mixpanel event tracking functions
export const trackEvent = (eventName, properties = {}) => {
  safeMixpanelOperation(() => {
  mixpanel.track(eventName, properties);
  });
};

// Event tracking functions
export const trackNotesLoaded = (noteCount) => {
  trackEvent('notes_loaded', { noteCount });
};

export const trackNoteOpened = (noteId) => {
  trackEvent('note_opened', { noteId });
};

export const trackNoteDeleted = (noteId) => {
  trackEvent('note_deleted', { noteId });
};

export const trackNoteCreated = (noteId, isManual, recordingDuration, transcriptWords, summaryWords) => {
  trackEvent('note_created', {
    noteId,
    isManual,
    recordingDuration,
    transcriptWords,
    summaryWords
  });
};

export const trackLogin = (method, uid) => {
  trackEvent('login', { method, uid });
};

export const trackSignUp = (method, uid) => {
  trackEvent('sign_up', { method, uid });
};

// New function for Firebase note_created event
export const trackFirebaseNoteCreated = (noteId, recordingDuration) => {
  trackEvent('note_created', {
    noteId,
    recordingDuration
  });
};

// Note context menu actions
export const trackNotePinned = (noteId) => {
  trackEvent('notePinned', { noteId });
};

export const trackNoteUnpinned = (noteId) => {
  trackEvent('noteUnpinned', { noteId });
};

export const trackNoteShare = (noteId) => {
  trackEvent('noteShare', { noteId });
};

export const trackNotePrint = (noteId) => {
  trackEvent('notePrint', { noteId });
};

export const trackNoteResend = (noteId) => {
  trackEvent('noteResend', { noteId });
};

export const trackNoteResummarize = (noteId) => {
  trackEvent('noteResummarize', { noteId });
};

export const trackNoteRetranscript = (noteId) => {
  trackEvent('noteRetranscript', { noteId });
};

export const trackNotesBulkDelete = (count) => {
  trackEvent('notesBulkDelete', { count });
};

// Add more tracking functions as needed...
